export default {"main":"LUSnEW_main","form":"LUSnEW_form","heading":"LUSnEW_heading",}